(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lg-basket-sync"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialise = () => {
    const $ = window.jQuery;
    if (!$ || window.DLPaintBasketSync || !document.querySelector('lg-paint-selector')) return;
    const state = { version: '3.1', status: 'idle' };
    window.DLPaintBasketSync = state;
    const cartPath = window.Theme?.routes?.cart_url || '/cart';
    const cartURL = new URL(cartPath, location.origin);
    const requests = new WeakMap();
    let active = null;
    let sequence = 0;
    const setBusy = busy => document.querySelectorAll('[data-cart-mini-toggle]').forEach(button => {
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
    const fail = cycle => {
      if (active !== cycle) return;
      clearTimeout(cycle.timer);
      active = null;
      state.status = 'failed';
      setBusy(false);
    };
    const finish = cycle => {
      if (active !== cycle || !cycle.countDone || !cycle.drawerDone) return;
      clearTimeout(cycle.timer);
      active = null;
      state.status = 'ready';
      setBusy(false);
      document.querySelectorAll('[data-cart-mini-count]').forEach(node => {
        node.textContent = cycle.count === 0 ? '' : String(cycle.count);
      });
      requestAnimationFrame(() => {
        if (sequence !== cycle.id || active) return;
        const button = document.querySelector('[data-cart-mini-toggle]');
        if (button) button.click();
      });
    };
    document.addEventListener('cart:refresh', () => {
      if (active) clearTimeout(active.timer);
      const cycle = { id: ++sequence, countDone: false, drawerDone: false, count: 0 };
      active = cycle;
      state.status = 'refreshing';
      setBusy(true);
      cycle.timer = setTimeout(() => fail(cycle), 10000);
    }, true);
    $(document).on('ajaxSend.dlPaintBasketSync', (event, request, settings) => {
      if (!active) return;
      const url = new URL(settings.url, location.href);
      if (url.origin !== cartURL.origin) return;
      const kind = url.pathname === `${cartURL.pathname}.js` ? 'count'
        : url.pathname === cartURL.pathname && url.searchParams.get('view') === 'mini' ? 'drawer' : null;
      if (!kind) return;
      requests.set(request, { cycle: active, kind });
    });
    $(document).on('ajaxComplete.dlPaintBasketSync', (event, request) => {
      const tracked = requests.get(request);
      if (!tracked || tracked.cycle !== active) return;
      const { cycle, kind } = tracked;
      if (request.status < 200 || request.status >= 300) { fail(cycle); return; }
      if (kind === 'count') {
        const count = request.responseJSON?.item_count;
        if (!Number.isInteger(count)) { fail(cycle); return; }
        cycle.count = count;
        cycle.countDone = true;
      } else {
        cycle.drawerDone = true;
      }
      finish(cycle);
    });
    document.addEventListener('click', event => {
      const button = event.target.closest?.('[data-cart-mini-toggle]');
      if (!button) return;
      if (active) {
        event.preventDefault();
        event.stopImmediatePropagation();
      } else if (state.status === 'failed') {
        event.preventDefault();
        event.stopImmediatePropagation();
        location.assign(cartPath);
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lg-paint-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lg-paint-selector')) {
  customElements.define('lg-paint-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const data = key => JSON.parse(this.querySelector(`[data-lg-${key}]`).textContent);
      this.colours = data('colours'); this.finishes = data('finishes'); this.products = data('products'); this.strings = data('strings');
      this.inspiration = data('inspiration');
      this.el = key => this.querySelector(`[data-lg-${key}]`);
      this.collection = this.dataset.collection === 'colour-scales' ? 'colour-scales' : 'colours-of-england';
      const initial = this.products.find(p => String(p.id) === this.dataset.productId);
      this.finish = this.finishes.find(f => f.products.some(p => p.handle === initial?.handle)) || this.finishes[0];
      this.size = this.finish.products.find(p => p.handle === initial?.handle)?.size || '';
      this.sample = initial?.handle === 'absolute-matt-emulsion-60ml-sample-pot';
      if(this.sample){this.size='60ml';this.finish=this.finishes.find(f=>f.code==='0206')||this.finish;}
      const params = new URLSearchParams(location.search);
      const requestedFinish = this.finishes.find(f => f.code === params.get('finish'));
      if(requestedFinish) this.finish = requestedFinish;
      this.colour = this.colours.find(c => c.key === params.get('colour')) || null;
      if(this.colour && !this.colour.collections.includes(this.collection)) this.collection = this.colour.collections[0];
      this.finishes.forEach(f => { const o = document.createElement('option'); o.value=f.code; o.textContent=f.name; this.el('finish').append(o); const h=document.createElement('h3');h.textContent=f.name;const p=document.createElement('p');p.textContent=f.description;this.el('finish-guide').append(h,p); });
      this.el('finish').value=this.finish.code;
      this.el('finish').addEventListener('change',()=>{this.finish=this.finishes.find(f=>f.code===this.el('finish').value);this.size='';this.render();});
      this.querySelectorAll('[data-lg-collection]').forEach(b=>b.addEventListener('click',()=>{this.collection=b.dataset.lgCollection;this.el('search').value='';this.el('group').value='';this.renderGroups();this.renderGrid();}));
      this.el('search').addEventListener('input',()=>this.renderGrid());
      this.el('group').addEventListener('change',()=>this.renderGrid());
      this.el('jump').addEventListener('click',()=>this.el('selection').closest('section').scrollIntoView({behavior:'smooth',block:'start'}));
      this.el('form').addEventListener('submit',e=>this.addToCart(e));
      this.el('quantity').addEventListener('input',()=>this.renderPrice());
      this.el('selected-inspiration').addEventListener('click',e=>this.openInspiration(this.colour,e.currentTarget));
      this.el('gallery-close').addEventListener('click',()=>this.el('gallery').close());
      this.el('gallery-previous').addEventListener('click',()=>this.changePhoto(-1));
      this.el('gallery-next').addEventListener('click',()=>this.changePhoto(1));
      this.el('gallery').addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.changePhoto(e.key==='ArrowLeft'?-1:1);}});
      this.el('gallery').addEventListener('click',e=>{if(e.target===this.el('gallery')){const r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}});
      this.el('gallery').addEventListener('close',()=>{document.documentElement.style.overflow=this.galleryScroll||'';this.galleryTrigger?.focus({preventScroll:true});});
      this.renderGroups();this.render();
    }
    text(key,vars={}){let s=this.strings[key]||key;for(const [k,v] of Object.entries(vars))s=s.replaceAll(`{${k}}`,v);return s;}
    openInspiration(colour,trigger){
      if(!colour||!this.inspiration[colour.key]?.length)return;
      this.galleryColour=colour;this.galleryTrigger=trigger;this.galleryIndex=0;
      this.galleryPhotos=this.inspiration[colour.key]||[];
      this.el('gallery-title').textContent=colour.name+(colour.number?' · '+colour.number:'');
      this.renderPhoto();
      this.galleryScroll=document.documentElement.style.overflow;
      this.el('gallery').showModal();document.documentElement.style.overflow='hidden';
    }
    changePhoto(direction){if(this.galleryPhotos.length<2)return;this.galleryIndex=(this.galleryIndex+direction+this.galleryPhotos.length)%this.galleryPhotos.length;this.renderPhoto();}
    renderPhoto(){
      const photo=this.galleryPhotos[this.galleryIndex],frame=this.el('gallery-photo'),status=this.el('gallery-status');
      frame.replaceChildren();status.textContent=this.text(photo?'photo_loading':'photo_unavailable');
      this.el('gallery-count').textContent=photo?this.text('photo_count',{current:this.galleryIndex+1,total:this.galleryPhotos.length}):'';
      this.el('gallery-previous').hidden=this.el('gallery-next').hidden=this.galleryPhotos.length<2;
      if(!photo)return;
      const img=document.createElement('img');img.alt=this.text('photo_alt',{colour:this.galleryColour.name});img.decoding='async';
      img.addEventListener('load',()=>{if(frame.contains(img))status.textContent='';});
      img.addEventListener('error',()=>{if(frame.contains(img)){img.hidden=true;status.textContent=this.text('photo_unavailable');}});
      img.src=photo.url;
      frame.append(img);
    }
    variantFor(item){const p=this.products.find(p=>p.handle===item?.handle);const expected=this.colour?.prices?.[this.finish.code]?.[item?.size];const v=item?.size==='60ml'||!this.colour?p?.variants?.[0]:p?.variants?.find(v=>v.price===expected);return v?{product:p,variant:v}:null;}
    supported(colour,size){if(!colour)return false;if(size==='60ml')return this.finish.code==='0206'&&Boolean(colour.sample);return Boolean(colour.availability?.[this.finish.code]?.includes(size));}
    hasFinish(colour){return this.finish.products.some(p=>this.supported(colour,p.size));}
    renderGroups(){const s=this.el('group');s.replaceChildren();const o=document.createElement('option');o.value='';o.textContent=this.text('all_groups');s.append(o);const groups=[...new Set(this.colours.filter(c=>c.collections.includes(this.collection)).flatMap(c=>this.collection==='colour-scales'?(c.groups||[]):[c.family]).filter(Boolean))];groups.forEach(g=>{const o=document.createElement('option');o.value=g;o.textContent=g;s.append(o);});}
    render(){this.el('finish-description').textContent=this.finish.description;this.el('finish-note').textContent=this.finish.note||'';this.renderGrid();this.renderOrder();}
    renderGrid(){
      this.querySelectorAll('[data-lg-collection]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.lgCollection===this.collection)));
      this.el('collection-description').textContent=this.text(this.collection==='colour-scales'?'scales_description':'england_description');
      const q=this.el('search').value.toLowerCase().trim(),group=this.el('group').value;
      const matching=this.colours.filter(c=>c.collections.includes(this.collection)&&(!q||`${c.name} ${c.number}`.toLowerCase().includes(q))&&(!group||(this.collection==='colour-scales'?(c.groups||[]).includes(group):c.family===group)));
      if(this.collection==='colour-scales')matching.sort((a,b)=>a.scalePosition-b.scalePosition);
      this.el('grid').replaceChildren();
      matching.forEach(c=>{const card=document.createElement('div');card.className='lg-paint__colour-card';const b=document.createElement('button');b.type='button';b.className='lg-paint__swatch';b.dataset.key=c.key;b.dataset.unavailable=String(!this.hasFinish(c));b.setAttribute('aria-pressed',String(this.colour?.key===c.key));b.setAttribute('aria-label',`${c.name}${c.number?' '+c.number:''}${!this.hasFinish(c)?'. '+this.text('finish_not_available'):''}`);const chip=document.createElement('span');chip.className='lg-paint__chip';chip.style.backgroundColor=c.hex;const name=document.createElement('span');name.className='lg-paint__swatch-name';name.textContent=c.name;const num=document.createElement('span');num.className='lg-paint__swatch-number';num.textContent=c.number||'\u00a0';b.append(chip,name,num);b.addEventListener('click',()=>{this.colour=c;this.size='';this.el('message').textContent='';this.el('basket').hidden=true;this.querySelectorAll('[data-lg-grid] .lg-paint__swatch').forEach(btn=>btn.setAttribute('aria-pressed',String(btn.dataset.key===c.key)));this.renderOrder();const url=new URL(location.href);url.searchParams.set('colour',c.key);url.searchParams.set('finish',this.finish.code);history.replaceState(null,'',url);});card.append(b);const inspiration=document.createElement('button');inspiration.type='button';inspiration.className='lg-paint__inspiration';inspiration.textContent=this.text('inspiration');inspiration.setAttribute('aria-label',this.text('inspiration_for',{colour:c.name}));inspiration.setAttribute('aria-haspopup','dialog');inspiration.setAttribute('aria-controls',this.el('gallery').id);inspiration.addEventListener('click',()=>this.openInspiration(c,inspiration));if(this.inspiration[c.key]?.length)card.append(inspiration);this.el('grid').append(card);});
      this.el('count').textContent=this.text('count',{count:matching.length});this.el('empty').hidden=matching.length>0;
    }
    renderOrder(){
      const c=this.colour;this.el('mobile').hidden=!c;this.el('mobile-name').textContent=c?.name||'';this.el('selection').hidden=!c;this.el('prompt').hidden=Boolean(c);this.el('unavailable').hidden=!c||this.hasFinish(c);
      if(c){this.el('selected-inspiration').hidden=!this.inspiration[c.key]?.length;this.el('selected-swatch').style.backgroundColor=c.hex;this.el('selected-name').textContent=c.name+(c.number?' · '+c.number:'');this.el('colour-description').textContent=c.description||'';const facts=[];if(c.family)facts.push(c.family);if(c.lrv!==null&&c.lrv!==undefined&&c.lrv!=='')facts.push(this.text('lrv',{value:c.lrv}));this.el('colour-facts').textContent=facts.join(' · ');}
      const sample={size:'60ml',handle:'absolute-matt-emulsion-60ml-sample-pot'};const choices=[...(this.finish.code==='0206'?[sample]:[]),...this.finish.products];this.choices=choices;
      if(this.size&&!choices.some(p=>p.size===this.size&&this.variantFor(p)?.variant.available&&this.supported(c,p.size)))this.size='';
      this.el('sizes').replaceChildren();
      choices.forEach(item=>{const v=this.variantFor(item);if(!v)return;const label=document.createElement('label');label.className='lg-paint__size';const radio=document.createElement('input');radio.type='radio';radio.name='lg-size';radio.value=item.size;radio.disabled=!v.variant.available||!this.supported(c,item.size);radio.checked=this.size===item.size;const span=document.createElement('span');span.textContent=item.size==='60ml'?this.text('sample_size'):item.size;label.append(radio,span);radio.addEventListener('change',()=>{this.size=item.size;this.renderPrice();});this.el('sizes').append(label);});
      this.renderPrice();
    }
    renderPrice(){const item=this.choices?.find(p=>p.size===this.size);this.selected=item?this.variantFor(item):null;const valid=Boolean(this.selected?.variant.available&&this.supported(this.colour,this.size));const qty=Number(this.el('quantity').value);this.el('add').disabled=!valid||!Number.isInteger(qty)||qty<1||qty>99||this.busy;this.el('price').textContent=valid?new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(this.selected.variant.price/100*qty):'';this.el('product-name').textContent=valid?this.selected.product.title:'';this.el('sample-note').hidden=this.size!=='60ml';this.el('primer-note').hidden=this.finish.code!=='0215'||this.size==='60ml';}
    async addToCart(e){e.preventDefault();if(this.el('add').disabled||!this.selected||!this.colour)return;this.busy=true;this.renderPrice();this.el('message').textContent=this.text('adding');this.el('basket').hidden=true;const quantity=Number(this.el('quantity').value);const properties={Colour:this.colour.name+(this.colour.number?' ('+this.colour.number+')':''),Finish:this.size==='60ml'?'Absolute Matt Emulsion':this.finish.name,Size:this.size};try{const response=await fetch(`${this.dataset.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.selected.variant.id,quantity,properties}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||this.text('error'));this.el('message').textContent=this.text('added',{colour:this.colour.name});this.el('basket').hidden=false;document.dispatchEvent(new CustomEvent('cart:refresh'));}catch(error){this.el('message').textContent=error.message||this.text('error');}finally{this.busy=false;this.renderPrice();}}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-review-fixes"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.main-header--nav-links details[data-nav-details]';
    const syncMenu = (details) => {
      const item = details.parentElement;
      const summary = details.querySelector(':scope > summary');
      const menu = item.querySelector(':scope > .dropdown-wrap');
      if (!summary || !menu) return;
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-controls', menu.id);
      summary.setAttribute('aria-expanded', String(details.open));
      item.setAttribute('aria-expanded', String(details.open));
      menu.setAttribute('aria-hidden', String(!details.open));
    };
    const initialise = () => document.querySelectorAll(selector).forEach(syncMenu);
    document.addEventListener('toggle', (event) => {
      if (event.target.matches?.(selector)) syncMenu(event.target);
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('.main-header--nav-links');
      if (!menu) return;
      const openMenus = [...menu.querySelectorAll('details[open]')];
      const current = openMenus.reverse().find((details) => details.parentElement.contains(event.target));
      if (!current) return;
      event.preventDefault();
      current.open = false;
      syncMenu(current);
      current.querySelector(':scope > summary').focus();
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialise, { once: true });
    } else {
      initialise();
    }
    document.addEventListener('shopify:section:load', initialise);
  })();
  } catch(e) { console.error(e); }
})();

})();
